import { TEntityOverride } from 'src/types'

const override: TEntityOverride = {
  titleField: 'id',
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
    },
  },
  create: {
    properties: {
      passportId: {
        displayedName: 'Passport',
        reference: {
          target: 'Passport',
          targetLabelKeyPath: 'username',
        },
      },
    },
  },
  edit: {
    properties: {
      passportId: {
        displayedName: 'Passport',
        reference: {
          target: 'Passport',
          targetLabelKeyPath: 'username',
        },
      },
    },
  },
}

export default override
